import React from 'react';
import { Accordion } from '../common/Accordion';
import { getOperatorOptions, getAvailableFields } from '../utils';
import { shouldExcludeConditionsAndValidations } from '../constants/fieldTypeGroups';

/**
 * Conditions property component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ConditionsProperty = _ref => {
  let {
    field,
    fields,
    selectedField,
    updateCondition,
    removeCondition,
    addCondition,
    accordionStates,
    toggleAccordion
  } = _ref;
  const shouldExclude = shouldExcludeConditionsAndValidations(field.type);
  if (shouldExclude) {
    return null;
  }
  const availableFields = getAvailableFields(fields, selectedField);
  return /*#__PURE__*/_jsxs(Accordion, {
    title: "Conditions",
    isOpen: accordionStates.conditions,
    onToggle: () => toggleAccordion('conditions'),
    children: [/*#__PURE__*/_jsx("p", {
      className: "conditions-help",
      children: "Show this field only when certain conditions are met"
    }), /*#__PURE__*/_jsxs("div", {
      className: "conditions-section",
      children: [field.conditions?.map((condition, index) => {
        const sourceField = fields.find(f => f.id === condition.sourceFieldId);
        const operatorOptions = getOperatorOptions(sourceField?.type || 'text');
        return /*#__PURE__*/_jsxs("div", {
          className: "condition-item",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "condition-header",
            children: [/*#__PURE__*/_jsxs("span", {
              className: "condition-number",
              children: ["Condition ", index + 1]
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: () => removeCondition(index),
              className: "remove-condition-btn",
              title: "Remove condition",
              children: "\xD7"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "condition-row",
            children: [/*#__PURE__*/_jsx("label", {
              className: "condition-field-label",
              children: "When field"
            }), /*#__PURE__*/_jsxs("select", {
              value: condition.sourceFieldId || '',
              onChange: e => updateCondition(index, 'sourceFieldId', e.target.value),
              className: "condition-input",
              children: [/*#__PURE__*/_jsx("option", {
                value: "",
                children: "Select field..."
              }), availableFields.map(f => /*#__PURE__*/_jsx("option", {
                value: f.id,
                children: f.label
              }, f.id))]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "condition-row",
            children: [/*#__PURE__*/_jsx("label", {
              className: "condition-field-label",
              children: "Operator"
            }), /*#__PURE__*/_jsx("select", {
              value: condition.operator || 'equals',
              onChange: e => updateCondition(index, 'operator', e.target.value),
              className: "condition-input",
              children: operatorOptions.map(operator => /*#__PURE__*/_jsx("option", {
                value: operator.value,
                children: operator.label
              }, operator.value))
            })]
          }), !['is_empty', 'is_not_empty'].includes(condition.operator) && /*#__PURE__*/_jsxs("div", {
            className: "condition-row",
            children: [/*#__PURE__*/_jsx("label", {
              className: "condition-field-label",
              children: "Value"
            }), /*#__PURE__*/_jsx("input", {
              type: sourceField?.type === 'number' ? 'number' : 'text',
              value: condition.value || '',
              onChange: e => updateCondition(index, 'value', e.target.value),
              className: "condition-input",
              placeholder: "Enter value..."
            })]
          })]
        }, index);
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: addCondition,
        className: "add-condition-btn",
        children: "+ Add Condition"
      }), field.conditions && field.conditions.length > 1 && /*#__PURE__*/_jsx("div", {
        className: "conditions-logic",
        children: /*#__PURE__*/_jsx("p", {
          className: "logic-help",
          children: "All conditions must be true for this field to be shown (AND logic)"
        })
      })]
    })]
  });
};